/*
  Complément minimal pour le thème repris.

  Leur thème s'appuyait sur un script externe (js.shrinetheme.com) pour quelques
  utilitaires. On ne peut pas en dépendre : il est servi depuis leur compte.
  Charger le global.js de Dawn à la place ne marche pas non plus — il redéclare
  des classes que leur secondary.js définit déjà, et la deuxième déclaration
  casse tout le fichier.

  On ne fournit donc que ce qui manque réellement, avant leurs scripts.
*/
if (typeof window.debounce !== 'function') {
  window.debounce = function (fn, delai) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), delai);
    };
  };
}
if (typeof window.fetchConfig !== 'function') {
  window.fetchConfig = function (type = 'json') {
    return { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: `application/${type}` } };
  };
}

/* Complements Dawn manquants dans ce theme : ModalDialog & co.
   Ajoutes parce que product-modal.js et quick-add.js en heritent. */
(function () {
  if (typeof window.getFocusableElements !== "function") {
    function getFocusableElements(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    }
    window.getFocusableElements = getFocusableElements;
  }
  var getFocusableElements = window.getFocusableElements;
  if (typeof window.trapFocus !== "function") {
    function trapFocus(container, elementToFocus = container) {
      var elements = getFocusableElements(container);
      var first = elements[0];
      var last = elements[elements.length - 1];
    
      removeTrapFocus();
    
      trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) return;
    
        document.addEventListener('keydown', trapFocusHandlers.keydown);
      };
    
      trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
      };
    
      trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          first.focus();
        }
    
        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
          event.preventDefault();
          last.focus();
        }
      };
    
      document.addEventListener('focusout', trapFocusHandlers.focusout);
      document.addEventListener('focusin', trapFocusHandlers.focusin);
    
      elementToFocus.focus();
    
      if (
        elementToFocus.tagName === 'INPUT' &&
        ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
        elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
      }
    }
    window.trapFocus = trapFocus;
  }
  var trapFocus = window.trapFocus;
  if (typeof window.removeTrapFocus !== "function") {
    function removeTrapFocus(elementToFocus = null) {
      document.removeEventListener('focusin', trapFocusHandlers.focusin);
      document.removeEventListener('focusout', trapFocusHandlers.focusout);
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    
      if (elementToFocus) elementToFocus.focus();
    }
    window.removeTrapFocus = removeTrapFocus;
  }
  var removeTrapFocus = window.removeTrapFocus;
  if (typeof window.pauseAllMedia !== "function") {
    function pauseAllMedia() {
      document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
      });
      document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      document.querySelectorAll('video').forEach((video) => video.pause());
      document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      });
    }
    window.pauseAllMedia = pauseAllMedia;
  }
  var pauseAllMedia = window.pauseAllMedia;
  if (typeof window.ModalDialog === "undefined") {
    class ModalDialog extends HTMLElement {
      constructor() {
        super();
        this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        if (this.classList.contains('media-modal')) {
          this.addEventListener('pointerup', (event) => {
            if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
          });
        } else {
          this.addEventListener('click', (event) => {
            if (event.target === this) this.hide();
          });
        }
      }
    
      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
        document.body.appendChild(this);
      }
    
      show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
      }
    
      hide() {
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
      }
    }
    window.ModalDialog = ModalDialog;
  }
  if (typeof window.ModalOpener === "undefined") {
    class ModalOpener extends HTMLElement {
      constructor() {
        super();
    
        const button = this.querySelector('button');
    
        if (!button) return;
        button.addEventListener('click', () => {
          const modal = document.querySelector(this.getAttribute('data-modal'));
          if (modal) modal.show(button);
        });
      }
    }
    window.ModalOpener = ModalOpener;
  }
  if (typeof window.DeferredMedia === "undefined") {
    class DeferredMedia extends HTMLElement {
      constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener('click', this.loadContent.bind(this));
      }
    
      loadContent(focus = true) {
        window.pauseAllMedia();
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
    
          this.setAttribute('loaded', true);
          const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
          if (focus) deferredElement.focus();
          if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
            // force autoplay for safari
            deferredElement.play();
          }
    
          // Workaround for safari iframe bug
          const formerStyle = deferredElement.getAttribute('style');
          deferredElement.setAttribute('style', 'display: block;');
          window.setTimeout(() => {
            deferredElement.setAttribute('style', formerStyle);
          }, 0);
        }
      }
    }
    window.DeferredMedia = DeferredMedia;
  }
})();


/* Le clone n'embarquait pas le script d'apparition au defilement : la regle
   « .animate-section.animate--hidden .animate-item{opacity:0} » restait donc
   active pour toujours et le contenu ne s'affichait jamais. */
(function () {
  function reveler() {
    var sections = document.querySelectorAll(".animate-section.animate--hidden");
    if (!sections.length) return;
    if (!("IntersectionObserver" in window)) {
      sections.forEach(function (s) { s.classList.remove("animate--hidden"); });
      return;
    }
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.remove("animate--hidden");
        obs.unobserve(e.target);
      });
    }, { rootMargin: "600px 0px 600px 0px", threshold: 0 });
    sections.forEach(function (s) { obs.observe(s); });
    // Double filet : au moindre defilement on revele tout ce qui approche, et
    // au bout de 4 s on revele sans condition. Une section ne peut pas rester
    // invisible parce que l'observateur n'a pas repondu.
    function balayer(marge) {
      document.querySelectorAll(".animate-section.animate--hidden").forEach(function (s) {
        var r = s.getBoundingClientRect();
        if (marge === Infinity || r.top < window.innerHeight + marge) s.classList.remove("animate--hidden");
      });
    }
    window.addEventListener("scroll", function () { balayer(800); }, { passive: true });
    setTimeout(function () { balayer(800); }, 1200);
    setTimeout(function () { balayer(Infinity); }, 4000);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", reveler);
  else reveler();
})();


/* Le clone n'a jamais embarque la classe qui pilote <variant-selects> : changer
   de couleur ou de taille ne faisait donc rien et seule la variante par defaut
   etait achetable. On la reecrit a partir de la table du theme. */
(function () {
  function sansCentimes(s) {
    return String(s || "").replace(/,00(\s*)€/, "$1€").replace(/\s+/g, " ").trim();
  }
  function nombre(s) {
    var m = String(s || "").replace(/\s/g, "").match(/(\d+)[,.](\d{2})/);
    if (m) return parseInt(m[1], 10) * 100 + parseInt(m[2], 10);
    m = String(s || "").match(/(\d+)/);
    return m ? parseInt(m[1], 10) * 100 : 0;
  }

  function brancher(vs) {
    var section = vs.dataset.section;
    if (!section || vs.dataset.glBranche) return;
    vs.dataset.glBranche = "1";

    var brut = document.getElementById("PobConfig-" + section);
    var table = {};
    if (brut) {
      try {
        var cfg = JSON.parse(brut.textContent);
        // les cles de la table peuvent porter des segments vides en fin
        // (« kaki|| » pour un produit a une seule option) : on normalise.
        var poser = function (e) { table[String(e.o).replace(/\|+$/, '')] = e; };
        (cfg.pre || []).forEach(poser);
        (cfg.main || []).forEach(poser);
      } catch (err) {}
    }
    if (!Object.keys(table).length) return;

    function euro(centimes) {
      return (centimes / 100).toFixed(2).replace(".", ",") + " €";
    }
    // La table figee vient de la boutique d'origine : son stock et ses prix
    // peuvent etre faux. On la recouvre avec les donnees reelles du produit.
    function recouvrir(prod) {
      (prod.variants || []).forEach(function (v) {
        var k = v.options.map(function (o) { return String(o).toLowerCase(); })
                         .join("|").replace(/\|+$/, "");
        table[k] = {
          id: v.id, o: k, a: v.available !== false,
          p: euro(v.price),
          c: v.compare_at_price && v.compare_at_price > v.price ? euro(v.compare_at_price) : null
        };
      });
    }

    var form = document.getElementById("product-form-" + section) ||
               vs.closest(".shopify-section, section, div").querySelector('form[action*="/cart/add"]');
    var champId = form && form.querySelector('[name="id"]');
    var groupes = [].slice.call(vs.querySelectorAll(".product-form__input"));
    if (!groupes.length || !champId) return;

    var racine = document.getElementById("ProductInfo-" + section) || document;
    var bouton = (form || document).querySelector('button[name="add"], .product-form__submit');

    function cle() {
      return groupes.map(function (g) {
        var c = g.querySelector('input[type="radio"]:checked');
        return c ? c.value.toLowerCase() : "";
      }).join("|").replace(/\|+$/, "");
    }

    function majLibelles() {
      groupes.forEach(function (g, i) {
        var c = g.querySelector('input[type="radio"]:checked');
        if (!c) return;
        var l = document.getElementById("custom-label-" + section + "-" + (i + 1));
        if (l) l.textContent = " " + c.name + " - " + c.value + " ";
      });
    }

    function majMedias() {
      var c = groupes[0] && groupes[0].querySelector('input[type="radio"]:checked');
      if (!c) return;
      var valeur = c.value;
      var vus = 0;
      ["#Slider-Thumbnails-" + section + " > li", "#Slider-Gallery-" + section + " > li",
       ".product__media-item", ".thumbnail-list__item"].forEach(function (sel) {
        [].slice.call(racine.querySelectorAll(sel)).forEach(function (el) {
          if (!el.dataset.alt) return;
          var garde = el.dataset.alt === valeur;
          el.classList.toggle("hidden", !garde);
          el.classList.toggle("is-active", false);
          if (garde) vus++;
        });
      });
      if (!vus) {   // aucun media pour cette couleur : on remontre tout
        [].slice.call(racine.querySelectorAll("[data-alt]")).forEach(function (el) {
          el.classList.remove("hidden");
        });
      }
      var premier = racine.querySelector(".product__media-item:not(.hidden)");
      if (premier && premier.parentElement) premier.parentElement.scrollLeft = 0;
    }

    function majPrix(e) {
      var p = e ? e.p : null, c = e ? e.c : null;
      [].slice.call(racine.querySelectorAll(".main-price")).forEach(function (el) { if (p) el.textContent = p; });
      [].slice.call(racine.querySelectorAll(".main-comapre-price, .main-compare-price")).forEach(function (el) {
        if (c) el.textContent = c;
        el.closest("s") && (el.closest("s").style.display = c && nombre(c) > nombre(p) ? "" : "none");
      });
      var pc = racine.querySelector(".badge__percentage-saved");
      var solde = racine.querySelector(".price__badge-sale");
      var epuise = racine.querySelector(".price__badge-sold-out");
      // le theme source tronque la remise (179 -> 99 affiche 44 %, pas 45 %)
      var remise = (p && c && nombre(c) > 0) ? Math.floor((1 - nombre(p) / nombre(c)) * 100) : 0;
      if (pc) pc.textContent = remise + "\u202f";  // espace fine avant le %
      if (solde) solde.style.display = remise > 0 ? "" : "none";
      if (epuise) epuise.style.display = (e && e.a === false) ? "" : "none";
      var cmp = racine.querySelector(".pob-prices__compare");
      var now = racine.querySelector(".pob-prices__now");
      if (cmp && c) cmp.textContent = sansCentimes(c);
      if (now && p) now.textContent = sansCentimes(p);
    }

    function majBouton(e) {
      if (!bouton) return;
      var libelle = bouton.querySelector(".main-atc__label__text");
      var dispo = !!(e && e.a !== false);
      bouton.disabled = !dispo;
      bouton.classList.toggle("disabled", !dispo);
      if (libelle) libelle.textContent = dispo ? " Ajouter au panier " : " Épuisé ";
      var prix = bouton.querySelector(".pob-prices");
      if (prix) prix.style.display = dispo ? "" : "none";
    }

    function appliquer() {
      var e = table[cle()];
      if (e) {
        // la page porte plusieurs formulaires produit (dont un reliquat
        // de l'ancien bandeau de paiement) : on les met tous a jour.
        [].slice.call(document.querySelectorAll('form[action*="/cart/add"] [name="id"]'))
          .forEach(function (ch) { ch.value = e.id; });
        if (champId) champId.value = e.id;
      }
      majLibelles(); majMedias(); majPrix(e); majBouton(e);
      if (e && window.history && history.replaceState &&
          (!demandeInitiale || String(demandeInitiale) === String(e.id) || vs.dataset.glResolu)) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set("variant", e.id);
          history.replaceState({}, "", u.toString());
        } catch (err) {}
      }
      vs.dispatchEvent(new CustomEvent("gl:variante", { bubbles: true, detail: e || null }));
    }

    vs.addEventListener("change", function (ev) {
      if (ev.target && ev.target.type === "radio") appliquer();
    });

    // appliquer() reecrit l'URL : on retient la variante demandee des le depart.
    var demandeInitiale = new URLSearchParams(window.location.search).get("variant");

    function preselectionner(prod) {
      var demande = demandeInitiale;
      if (!demande) return false;
      var v = (prod.variants || []).filter(function (x) { return String(x.id) === String(demande); })[0];
      if (!v) return false;
      groupes.forEach(function (g, i) {
        var val = v.options[i];
        var r = [].slice.call(g.querySelectorAll('input[type="radio"]'))
                  .filter(function (x) { return x.value === val; })[0];
        if (r) r.checked = true;
      });
      return true;
    }

    appliquer();
    if (vs.dataset.url) {
      fetch(vs.dataset.url + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (prod) {
          if (!prod) return;
          recouvrir(prod);
          preselectionner(prod);
          vs.dataset.glResolu = "1";
          appliquer();
        })
        .catch(function () {});
    }
  }

  function demarrer() {
    [].slice.call(document.querySelectorAll("variant-selects")).forEach(brancher);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", demarrer);
  else demarrer();
})();


/* <internal-video> n'etait defini par aucun asset du clone. Les <source> sont
   en data-src : sans ce composant, aucune video ne se charge ni ne se lance.

   Ecrit en vraie classe : la version ES5 avec Reflect.construct faisait echouer
   la creation des elements par le parseur, donc connectedCallback ne partait
   jamais et les videos restaient figees sur leur image d'attente. */
(function () {
  if (customElements.get("internal-video")) return;

  class VideoInterne extends HTMLElement {
    // le script est charge dans le <head> : quand le parseur cree l'element,
    // son <video> enfant n'existe pas encore. On attend le document.
    connectedCallback() {
      var hote = this;
      if (hote.dataset.glPret) return;
      hote.dataset.glPret = "1";
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function () { hote.glInit(); });
      } else {
        hote.glInit();
      }
    }

    glInit() {
      var hote = this;
      var video = hote.querySelector("video");
      if (!video) return;
      hote.video = video;

      function charger() {
        if (hote.dataset.glCharge) return;
        hote.dataset.glCharge = "1";
        var utile = false;
        [].slice.call(hote.querySelectorAll("source[data-src]")).forEach(function (s) {
          // le flux m3u8 n'est lu nativement que par Safari : ailleurs on garde le mp4
          if (s.type === "application/x-mpegURL" &&
              !video.canPlayType("application/vnd.apple.mpegurl")) return;
          s.src = s.getAttribute("data-src"); utile = true;
        });
        if (!utile) {
          var mp4 = hote.querySelector('source[type="video/mp4"][data-src]');
          if (mp4) mp4.src = mp4.getAttribute("data-src");
        }
        try { video.load(); } catch (e) {}
      }

      function lire() {
        charger();
        // sans muted, le navigateur refuse la lecture automatique
        video.muted = true;
        video.setAttribute("muted", "");
        video.playsInline = true;
        var lancer = function () {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        };
        // load() annule un play() lance dans la foulee : on attend d'avoir de quoi lire
        if (video.readyState >= 2) lancer();
        else video.addEventListener("canplay", lancer, { once: true });
        hote.classList.add("internal-video--playing");
      }

      function suspendre() {
        try { video.pause(); } catch (e) {}
        hote.classList.remove("internal-video--playing");
      }

      var auto = hote.dataset.autoplay === "true";
      if ("IntersectionObserver" in window) {
        var obs = new IntersectionObserver(function (entrees) {
          entrees.forEach(function (e) {
            if (e.isIntersecting) { auto ? lire() : charger(); }
            else if (auto && hote.dataset.actionOnInactive !== "none") suspendre();
          });
        }, { rootMargin: "200px 0px", threshold: 0.1 });
        obs.observe(hote);
      } else { charger(); if (auto) lire(); }

      // filet : si l'observateur ne se declenche jamais (certains contextes ne le
      // font pas tourner), on verifie nous-memes au defilement et par a-coups.
      if (auto) {
        var verifier = function () {
          if (!video.paused) return;
          var r = hote.getBoundingClientRect();
          if (r.top < window.innerHeight + 200 && r.bottom > -200) lire();
        };
        [600, 1800, 3500].forEach(function (d) { setTimeout(verifier, d); });
        window.addEventListener('scroll', verifier, { passive: true });
        window.addEventListener('resize', verifier, { passive: true });
      }

      var boutonLecture = hote.querySelector(".internal-video__play");
      if (boutonLecture) {
        boutonLecture.addEventListener("click", function (ev) {
          ev.preventDefault(); ev.stopPropagation();
          video.paused ? lire() : suspendre();
        });
      }
      var boutonSon = hote.querySelector(".internal-video__sound-btn");
      if (boutonSon) {
        boutonSon.addEventListener("click", function (ev) {
          ev.preventDefault(); ev.stopPropagation();
          video.muted = !video.muted;
          hote.classList.toggle("internal-video--muted", video.muted);
        });
      }
    }
  }

  customElements.define("internal-video", VideoInterne);
})();


/* Deux composants du theme d'origine n'ont jamais ete copies :
   l'entete collante et la recherche instantanee. On les reecrit. */

/* --- entete collante ------------------------------------------------ */
if (!customElements.get('sticky-header')) {
  // vraie classe : le schema ES5 avec Reflect.construct empechait le navigateur
  // de creer l'element, donc connectedCallback ne partait jamais.
  class EnteteCollante extends HTMLElement {}

  EnteteCollante.prototype.connectedCallback = function () {
    var hote = this;
    if (hote.dataset.glPret) return;
    hote.dataset.glPret = '1';
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { hote.glInit(); });
    } else {
      hote.glInit();
    }
  };

  EnteteCollante.prototype.glInit = function () {
    var hote = this;
    var section = hote.closest('.shopify-section') || hote.parentElement;
    if (!section) return;
    var type = hote.dataset.stickyType || 'on-scroll-up';
    if (type === 'none') return;

    function mesurer() {
      // <sticky-header> englobe plus que la barre : on mesure le <header>.
      var barre = hote.querySelector('header') || hote;
      var h = barre.offsetHeight;
      if (h) document.documentElement.style.setProperty('--header-height', h + 'px');
      return h;
    }
    var hauteur = mesurer();
    window.addEventListener('resize', function () { hauteur = mesurer(); }, { passive: true });
    section.classList.add('shopify-section-header-sticky');

    var precedent = window.scrollY, enCours = false;
    function surDefilement() {
      var y = window.scrollY;
      section.classList.toggle('scrolled-past-header', y > hauteur);
      if (type === 'on-scroll-up') {
        var descend = y > precedent && y > hauteur * 1.5;
        var menuOuvert = section.querySelector('details[open], .menu-opening');
        section.classList.toggle('shopify-section-header-hidden', descend && !menuOuvert);
      }
      precedent = y;
      enCours = false;
    }
    window.addEventListener('scroll', function () {
      if (enCours) return;
      enCours = true;
      window.requestAnimationFrame ? requestAnimationFrame(surDefilement) : setTimeout(surDefilement, 16);
    }, { passive: true });
    surDefilement();
  };
  customElements.define('sticky-header', EnteteCollante);
}

/* --- recherche instantanee ------------------------------------------ */
if (!customElements.get('predictive-search')) {
  // vraie classe : le schema ES5 avec Reflect.construct empechait le navigateur
  // de creer l'element, donc connectedCallback ne partait jamais.
  class RechercheVive extends HTMLElement {}

  RechercheVive.prototype.connectedCallback = function () {
    var hote = this;
    if (hote.dataset.glPret) return;
    hote.dataset.glPret = '1';
    // le script est charge dans le <head> : a l'upgrade, les enfants de
    // l'element ne sont pas encore analyses. On attend le document.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { hote.glInit(); });
    } else {
      hote.glInit();
    }
  };

  RechercheVive.prototype.glInit = function () {
    var hote = this;
    var champ = hote.querySelector('input[name="q"]');
    var boite = hote.querySelector('[data-predictive-search]');
    var reset = hote.querySelector('.reset__button');
    if (!champ || !boite) return;

    var euro = function (p) {
      var n = typeof p === 'string' ? parseFloat(p.replace(',', '.')) : p;
      return isNaN(n) ? '' : n.toFixed(2).replace('.', ',') + ' €';
    };
    var echapper = function (s) {
      var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML;
    };
    var minuteur = null, dernier = '';

    function vider() {
      boite.innerHTML = '';
      hote.classList.remove('gl-recherche--ouverte');
      champ.setAttribute('aria-expanded', 'false');
    }

    function afficher(produits, terme) {
      if (!produits.length) {
        boite.innerHTML = '<p class="gl-recherche__vide">Aucun résultat pour « ' + echapper(terme) + ' ».</p>';
      } else {
        boite.innerHTML = '<ul class="gl-recherche__liste">' + produits.map(function (p) {
          var img = (p.featured_image && p.featured_image.url) || (p.image || '');
          return '<li><a class="gl-recherche__item" href="' + echapper(p.url) + '">' +
            (img ? '<img src="' + echapper(img) + '&width=120" alt="" width="52" height="52" loading="lazy">' : '<span class="gl-recherche__vignette"></span>') +
            '<span class="gl-recherche__texte"><span class="gl-recherche__titre">' + echapper(p.title) + '</span>' +
            '<span class="gl-recherche__prix">' + euro(p.price) + '</span></span></a></li>';
        }).join('') + '</ul>' +
        '<a class="gl-recherche__tout" href="/search?q=' + encodeURIComponent(terme) + '">Voir tous les résultats</a>';
      }
      hote.classList.add('gl-recherche--ouverte');
      champ.setAttribute('aria-expanded', 'true');
    }

    function chercher(terme) {
      var u = '/search/suggest.json?q=' + encodeURIComponent(terme) +
              '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(u, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (champ.value.trim() !== terme) return;   // l'utilisateur a continue a taper
          afficher(((d.resources || {}).results || {}).products || [], terme);
        })
        .catch(vider);
    }

    champ.addEventListener('input', function () {
      var terme = champ.value.trim();
      if (reset) reset.classList.toggle('hidden', !terme);
      if (terme === dernier) return;
      dernier = terme;
      clearTimeout(minuteur);
      if (terme.length < 2) { vider(); return; }
      minuteur = setTimeout(function () { chercher(terme); }, 250);
    });
    champ.addEventListener('focus', function () {
      if (champ.value.trim().length >= 2 && boite.innerHTML) hote.classList.add('gl-recherche--ouverte');
    });
    if (reset) reset.addEventListener('click', function () { dernier = ''; vider(); });
    document.addEventListener('click', function (e) { if (!hote.contains(e.target)) vider(); });
    champ.addEventListener('keyup', function (e) { if (e.key === 'Escape') vider(); });
  };
  customElements.define('predictive-search', RechercheVive);
}


/* Bouton « retour en haut » : apparait apres un debut de defilement. */
(function () {
  function brancher() {
    var b = document.querySelector('.gl-haut');
    if (!b || b.dataset.glPret) return;
    b.dataset.glPret = '1';
    b.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
    });
    function voir() {
      var y = window.scrollY || (document.scrollingElement || {}).scrollTop || 0;
      b.style.display = y > 600 ? '' : 'none';
    }
    window.addEventListener('scroll', voir, { passive: true });
    voir();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancher);
  else brancher();
})();
